import { queryKeysFactory } from "../queryKeyFactory";

const REGIONS_QUERY_KEY = "regions" as const;

export const regionsQueryKeys = {
  ...queryKeysFactory<
    //
    typeof REGIONS_QUERY_KEY
  >(REGIONS_QUERY_KEY)
};
